import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";

const BusDateLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            name: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >Nombre</Label>
                    <Input type="name" name="name"
                           placeholder="Ingrese un nombre"
                           value= { child.name }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
    />)
}

export default BusDateLangs